import React from "react";

const Arrow = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="31"
    height="162"
    viewBox="0 0 31 162"
    fill="none"
  >
    <path
      d="M16.7658 161.414C15.9847 162.195 14.7184 162.195 13.9373 161.414L1.20943 148.686C0.428379 147.905 0.428379 146.639 1.20943 145.858C1.99048 145.077 3.25681 145.077 4.03785 145.858L15.3516 157.172L26.6653 145.858C27.4463 145.077 28.7126 145.077 29.4937 145.858C30.2747 146.639 30.2747 147.905 29.4937 148.686L16.7658 161.414ZM15.3516 160L13.3516 160L13.3516 156.923L15.3516 156.923L17.3516 156.923L17.3516 160L15.3516 160ZM15.3516 150.769L13.3516 150.769L13.3516 144.615L15.3516 144.615L17.3516 144.615L17.3516 150.769L15.3516 150.769ZM15.3516 138.462L13.3516 138.462L13.3516 132.308L15.3516 132.308L17.3516 132.308L17.3516 138.462L15.3516 138.462ZM15.3516 126.154L13.3516 126.154L13.3516 120L15.3516 120L17.3516 120L17.3516 126.154L15.3516 126.154ZM15.3516 113.846L13.3516 113.846L13.3516 107.692L15.3516 107.692L17.3516 107.692L17.3516 113.846L15.3516 113.846ZM15.3516 101.538L13.3516 101.538L13.3516 95.3846L15.3516 95.3846L17.3516 95.3846L17.3516 101.538L15.3516 101.538ZM15.3516 89.2308L13.3516 89.2308L13.3516 83.0769L15.3516 83.0769L17.3516 83.0769L17.3516 89.2308L15.3516 89.2308ZM15.3516 76.9231L13.3516 76.9231L13.3516 70.7692L15.3516 70.7692L17.3516 70.7692L17.3516 76.9231L15.3516 76.9231ZM15.3516 64.6154L13.3516 64.6154L13.3516 58.4615L15.3516 58.4615L17.3516 58.4615L17.3516 64.6154L15.3516 64.6154ZM15.3516 52.3077L13.3516 52.3077L13.3516 46.1538L15.3516 46.1538L17.3516 46.1538L17.3516 52.3077L15.3516 52.3077ZM15.3516 40L13.3516 40L13.3516 33.8461L15.3516 33.8461L17.3516 33.8461L17.3516 40L15.3516 40ZM15.3516 27.6923L13.3516 27.6923L13.3516 21.5385L15.3516 21.5385L17.3516 21.5385L17.3516 27.6923L15.3516 27.6923ZM15.3516 15.3846L13.3516 15.3846L13.3516 9.23079L15.3516 9.23079L17.3516 9.23079L17.3516 15.3846L15.3516 15.3846ZM15.3516 3.07695L13.3516 3.07695L13.3516 -9.07817e-08L15.3516 0L17.3516 9.07817e-08L17.3516 3.07695L15.3516 3.07695Z"
      fill="white"
    />
  </svg>
);

const CircuitDemo = () => {
  return (
    <div className="w-full">
      <h3 className="gradient-text text-[50px] font-extrabold text-center mt-[80px]">
        BOOSTER
      </h3>
      <div className="mt-[140px] flex justify-between items-center px-[150px]">
        <div className="flex flex-col items-center">
          <h1 className="text-[64px] font-extrabold leading-[80px] text-white">
            1R - 3SET
          </h1>
          <h1 className="text-[90px] font-extrabold leading-[110px] mt-[16px] text-white">
            TOTAL 6R
          </h1>
        </div>
        <div className="flex flex-col items-center gap-[30px]">
          <div className="text-right text-white text-[36px] font-medium leading-[60px] px-[140px] self-end">
            목적에 맞춰 운동하세요!
          </div>
          <div className="relative">
            <div className="absolute left-[475px] -top-[20px] h-full z-50">
              <Arrow />
            </div>
            <div className="absolute left-[634px] -top-[20px] h-full z-50">
              <Arrow />
            </div>
            <div className="absolute left-[793px] -top-[20px] h-full z-50">
              <Arrow />
            </div>

            <div
              className="w-[963px] h-[100px] rounded-[100px] flex items-center justify-center relative"
              style={{
                border: "4px solid transparent",
                backgroundImage:
                  "linear-gradient(135deg, #E3FAFF 0%, #53CAF5 100%)",
                backgroundOrigin: "border-box",
              }}
            >
              <div className="w-full h-full bg-bg rounded-[100px] flex items-center">
                <div
                  className="h-[84px] rounded-[84px] flex justify-end mx-2 relative"
                  style={{
                    backgroundImage:
                      "linear-gradient(270deg, #53CAF5 0%, rgba(83, 202, 245, 0) 100%)",
                    transition: "all 0.5s ease",
                    width: "46.2%",
                    minWidth: "84px",
                  }}
                >
                  <div
                    className="w-[84px] h-[84px] rounded-[100px]"
                    style={{
                      backgroundImage:
                        "linear-gradient(135deg, #E3FAFF 0%, #53CAF5 100%)",
                    }}
                  ></div>
                </div>
              </div>
            </div>

            {/* Difficulty indicators */}
            <div className="relative w-[963px] h-[70px] mt-[60px]">
              <div className="absolute left-[429px] top-0 text-[44px] font-extrabold leading-[70px] text-center bg-gradient-to-br from-[#E3FAFF] to-[#53CAF5] bg-clip-text text-transparent">
                Easy
              </div>
              <div className="absolute left-[562px] top-0 text-[44px] font-extrabold leading-[70px] text-center bg-gradient-to-br from-[#FFF5E0] to-[#F6B731] bg-clip-text text-transparent">
                Normal
              </div>
              <div className="absolute left-[756px] top-0 text-[44px] font-extrabold leading-[70px] text-center bg-gradient-to-br from-[#FFEBEB] to-[#FF5757] bg-clip-text text-transparent">
                Hard
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="text-center text-white text-[48px] font-normal leading-[70px] mt-[60px]">
        컨디션에 맞춰 운동하세요!
      </div>
    </div>
  );
};

export default CircuitDemo;
